import React from "react";
import { Users, AlertCircle, Plus, XCircle, Trash2, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { RfqCard } from "../RfqCard";
import { subcontractTradeName } from "../../lib/subcontractWorkspace";

const money = (n) => "$" + Number(n || 0).toLocaleString();
const LIVE_RFQ = ["draft", "open", "negotiating", "review", "rejected", "approved"];

/* 分包商管理 · 未建合同的工种行：与阶段任务链完全相同的报价邀请卡（同一 RfqCard 组件 / 同一后台 /projects/{pid}/rfq）
   发起报价邀请 → 勾选候选 → 预览发送 → 分包商回价 / 预计开工 → 议价 → 对比表 → 选定 → 预算审核 → 合同草稿 → 发送签署；
   「直接建合同」为次要路径（已有分包商 / 手动定价），「不需要该工种」保留。 */
export const SubTradeRfqRow = ({ t, rfq, api, projectId, zh, canGen, canManageTrades, rfqPerm, creating, focused, onCreate, onExclude, onDelTrade, onChanged }) => {
  const live = rfq && LIVE_RFQ.includes(rfq.status);
  const estimate = rfq ? rfq.refBudget?.amount : t.estimate;
  const est = estimate != null && estimate > 0 ? `${zh ? "参考预算" : "Ref budget"} ${money(estimate)}` : (zh ? "参考预算待定" : "No ref budget yet");
  return (
    <div data-testid={`sub-todo-${t.tradeKey}`} data-rfq={rfq?.status || "none"} className={`bg-white border rounded-lg ${live ? "border-teal-300" : "border-slate-200"} ${focused ? "ring-2 ring-brand-300" : ""}`}>
      <div className="flex flex-wrap items-center gap-2 p-3">
        {live ? <Users className="h-3.5 w-3.5 text-teal-600 flex-shrink-0" /> : <AlertCircle className="h-3.5 w-3.5 text-slate-300 flex-shrink-0" />}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-slate-700 truncate flex items-center gap-1.5">{subcontractTradeName(t.tradeName, zh, t.tradeKey)}
            {!rfq && <span className="text-xs px-1.5 py-px rounded-full bg-slate-100 text-slate-500" data-testid={`sub-trade-state-${t.tradeKey}`}>{zh ? "未建合同 · 未询价" : "No contract · no RFQ"}</span>}
          </p>
          <p className="text-xs text-slate-400 truncate">{est}</p>
        </div>
        {canGen && (
          <>
            <Button data-testid={`sub-create-${t.tradeKey}`} size="sm" variant="outline" className="h-9 px-2 text-xs text-slate-600 border-slate-200 flex-shrink-0" disabled={creating} onClick={onCreate} title={zh ? "填写分包商与金额建立合同" : "Enter subcontractor and amount"}>
              {creating ? <Loader2 className="h-3 w-3 animate-spin" /> : <><Plus className="h-3 w-3 mr-0.5" />{zh ? "直接建合同" : "Create directly"}</>}
            </Button>
            {!t.extra && !t.existing && <Button data-testid={`sub-exclude-${t.tradeKey}`} size="sm" variant="ghost" className="h-9 px-1.5 text-slate-400 hover:text-red-500 flex-shrink-0" title={zh ? "此项目不需要该工种" : "Not needed"} onClick={onExclude}><XCircle className="h-3.5 w-3.5" /></Button>}
            {t.custom && canManageTrades && <Button data-testid={`sub-deltrade-${t.tradeKey}`} size="sm" variant="ghost" className="h-9 px-1.5 text-slate-400 hover:text-red-600 flex-shrink-0" title={zh ? "删除该标准工种（全项目）" : "Delete standard trade"} onClick={onDelTrade}><Trash2 className="h-3.5 w-3.5" /></Button>}
          </>
        )}
      </div>
      <RfqCard key={rfq?.id || "none"} api={api} id={projectId} node={rfq?.node || ""} tid={`sm-${t.tradeKey}`} trade={t.tradeKey} tradeName={t.tradeName} rfq={rfq || null} existingSub={null} zh={zh}
        canManage={!!rfqPerm.canManage} canReview={!!rfqPerm.canReview} onChanged={onChanged} defaultOpen={!!(live || focused)} context="list" />
    </div>
  );
};
